<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteGradeSheetDialog"
    :title="$t('grades.deleteTitle')"
    :confirm-text="$t('common.delete')"
    confirm-variant="danger"
    :loading="loading"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>{{ $t('grades.deleteConfirmation', { title: gradeSheetTitle }) }}</p>
      <p class="text-danger">{{ $t('grades.deleteWarning') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const loading = ref(false);
const gradeSheetTitle = ref('');
const gradeSheetId = ref(null);

const open = (gradeSheet) => {
  if (!gradeSheet || !gradeSheet.id) {
    console.error('Invalid grade sheet object:', gradeSheet);
    return;
  }
  
  gradeSheetTitle.value = gradeSheet.title || 'Untitled Grade Sheet';
  gradeSheetId.value = gradeSheet.id;
  loading.value = false;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = async () => {
  if (!gradeSheetId.value) {
    console.error('No grade sheet ID to delete');
    return;
  }
  
  loading.value = true;
  try {
    emit('delete', gradeSheetId.value);
    baseDialog.value?.closeDialog();
  } catch (error) {
    console.error('Delete confirmation error:', error);
  } finally {
    loading.value = false;
  }
};

defineExpose({ open });
</script>
